import { captureException, init } from '@sentry/browser'
import type { ComponentPublicInstance } from 'vue'

export const setupSentry = (dsn?: string) => {
    if (!dsn) {
        return
    }
    init({
        dsn,
        initialScope: {
            tags: {
                source: 'portal',
            },
        },
        sendClientReports: false,
        sampleRate: 0.1,
        // Ignore common non-informative errors
        ignoreErrors: [
            // Browser/rendering noise
            /ResizeObserver loop/,
            // Network errors (usually user connectivity issues)
            /Network Error/,
            /Failed to fetch/,
            /Load failed/,
            /AbortError/,
            /TypeError: cancelled/,
        ],
        // Deny errors from browser extensions and third-party scripts
        denyUrls: [
            // Third-party analytics/ads
            /google-analytics\.com/i,
            /googletagmanager\.com/i,
            /doubleclick\.net/i,
            /facebook\.net/i,
            /hotjar\.com/i,
            /googleapis\.com/i,
        ],
    })
}

export const errorComponentHandler = (err: unknown, instance: ComponentPublicInstance | null, info: string) => {
    captureException(err, {
        tags: { vue: true, component: instance?.$options.name },
        extra: { info },
    })
}
